import { render, staticRenderFns } from "./ListaReservas.vue?vue&type=template&id=b4c97de6&"
import script from "./ListaReservas.vue?vue&type=script&lang=ts&"
export * from "./ListaReservas.vue?vue&type=script&lang=ts&"
import style0 from "./ListaReservas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports